import api from "../service/api"; // your axios instance


export const getProgress = () => {
  return api.get("/progress");
};

export const getPayments = (scholarId) => {
  return api.get(`/sclr/payments/${scholarId}`);
};

export const getLastWorkStatus = async (scholarId) => {
  return api.get(`/workdetails/last-status/${scholarId}`);
};